import { SystemConfigrationView } from '../../Views/Home/Administration/SystemConfigrationView/SystemConfigrationView'

export const SystemConfigrationRoutes = [
  {
    path: '/view',
    name: 'general-configration',
    component: SystemConfigrationView,
    layout: '/home/rotation-configration',
    default: true,
    isRoute: true,
    authorize: true,
    roles: [],
    isDisabled: false,
    isExact: true,
    breadcrumbs: [
      {
        name: 'general-configration',
        isDisabled: true,
        route: '/home/rotation-configration/view',
        groupName: 'system-configuration',
      },
    ],
  },
];
